export default __webpack_public_path__ + "static/media/omg-cat.7f341b0d.gif";